import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchChatwootMeta } from '../api/chatwoot';
import ConversationAssignmentsTracePanel from '../components/ConversationAssignmentsTracePanel';
import { OPEN_CONVERSATION_KEY } from '../components/ChatwootAssignmentToastListener';
import '../styles/conversaciones-premium.css';
import '../styles/gestion-derivacion-premium.css';
import '../styles/pulse-ledger-premium.css';
import '../styles/trazabilidad-recetas-premium.css';
import '../styles/trazabilidad-asignaciones-premium.css';

export default function TrazabilidadAsignaciones() {
  const navigate = useNavigate();
  const [agents, setAgents] = useState([]);
  const [loadingAgents, setLoadingAgents] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchChatwootMeta()
      .then((json) => {
        if (cancelled) return;
        setAgents(json?.data?.agents || []);
      })
      .catch(() => {
        if (!cancelled) setAgents([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingAgents(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  function openConversation(conversationId) {
    if (!conversationId) return;
    try {
      sessionStorage.setItem(OPEN_CONVERSATION_KEY, String(conversationId));
    } catch {
      // ignore
    }
    navigate('/conversaciones');
  }

  return (
    <section className="crm-gd-page crm-pl-page crm-rtz-page crm-ta-page crm-pbody">
      <ConversationAssignmentsTracePanel
        standalone
        agentOptions={agents}
        loadingAgents={loadingAgents}
        onOpenConversation={openConversation}
      />
    </section>
  );
}
